import { Flex } from '@chakra-ui/react'
import { Chart, GoogleChartWrapper, ReactGoogleChartProps } from 'react-google-charts'
import { GoogleChartsDataTableValueTypes } from 'types'
import { useElementSize } from 'utils'

interface Props extends ReactGoogleChartProps {
  onSelect?: (selected: SelectProps) => void
}
interface SelectProps {
  label: string
  values?: GoogleChartsDataTableValueTypes[]
}

export default function GoogleChart({ onSelect, ...rest }: Props) {
  const { ref, width, height } = useElementSize()

  const chartEvents = [
    {
      eventName: 'select',
      callback: ({ chartWrapper }: { chartWrapper: GoogleChartWrapper }) => {
        const chart = chartWrapper.getChart()
        const selection = chart.getSelection()

        if (!selection || selection.length === 0) return

        const selectedItem = selection[0]
        const dataTable = chartWrapper.getDataTable()
        const colCount = dataTable?.getNumberOfColumns()

        if (selectedItem.row != null && colCount) {
          const selectedLabel = (dataTable?.getValue(selectedItem.row, 0) as string) || ''
          const selectedValues = []
          for (let i = 1; i < colCount; i++) {
            const colValue = dataTable?.getValue(selectedItem.row, i)
            if (colValue) selectedValues.push(colValue)
          }
          onSelect?.({ label: selectedLabel, values: selectedValues })
        }
      },
    },
  ]

  return (
    <Flex
      ref={ref}
      style={{ width: '100%', height: '100%' }}
      cursor={onSelect ? 'pointer' : 'default'}
    >
      {width > 0 && height > 0 && (
        <Chart {...rest} chartEvents={chartEvents as ReactGoogleChartProps['chartEvents']} />
      )}
    </Flex>
  )
}
